const transitionStr = (property: string, duration = '.2s', timingFunc = 'ease-in-out') =>
  [property, duration, timingFunc].join(' ');

export default {
  transition: (...properties: string[]) => properties.map((p) => transitionStr(p)).join(', '),
};
